import { render, staticRenderFns } from "./NotificationDetailsDialog.vue?vue&type=template&id=5e7d388d"
import script from "./NotificationDetailsDialog.vue?vue&type=script&lang=js"
export * from "./NotificationDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetailsDialog.vue?vue&type=style&index=0&id=5e7d388d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports